import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'

import { QUERY_KEYS } from '@/libs/constants'
import type { CreateOvertimePayload } from '@/libs/interfaces'
import { overtimesApi } from '@/services/api'

export function useOvertimeCreate() {
  const queryClient = useQueryClient()
  const { t } = useTranslation()
  return useMutation({
    mutationFn: ({
      employeeID,
      storeID,
      payload,
    }: {
      employeeID: string
      storeID: string
      payload: CreateOvertimePayload
    }) => overtimesApi.create(employeeID, storeID, payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: QUERY_KEYS.overtimes.all })
      toast.success(t('overtime.created'))
    },
    onError: () => {
      toast.error(t('common.error'))
    },
  })
}
